import React from 'react';
import CardItem from './CardItem';
import './Cards.css';

import AGoodAlien_Thumb from '../images/optimized/agoodalien-thumb.webp';
import KingsPath_Thumb from '../images/optimized/kingspath-thumb.webp';

import BalloonsOdyssey_Thumb from '../images/optimized/balloonsodyssey-thumb.webp';
import BalloonsOdysseyAdvertisement_Thumb from '../images/optimized/balloonsodyssey-advertisement-thumb.webp';
import BalloonsOdysseySettings_Thumb from '../images/optimized/balloonsodyssey-settings-thumb.webp';
import BalloonsOdysseyTournament_Thumb from '../images/optimized/balloonsodyssey-tournament-thumb.webp';

import BalloonsOdysseyWorldGUI_Thumb from '../images/optimized/balloonsodyssey-world-gui-thumb.webp';
import BalloonsOdysseyWorld01_Thumb from '../images/optimized/balloonsodyssey-world-01-thumb.webp';
import BalloonsOdysseyWorld02_Thumb from '../images/optimized/balloonsodyssey-world-02-thumb.webp';
import BalloonsOdysseyWorld03_Thumb from '../images/optimized/balloonsodyssey-world-03-thumb.webp';
import BalloonsOdysseyWorld04_Thumb from '../images/optimized/balloonsodyssey-world-04-thumb.webp';
import BalloonsOdysseyWorld05_Thumb from '../images/optimized/balloonsodyssey-world-05-thumb.webp';

import BalloonsOdysseyStore01_Thumb from '../images/optimized/balloonsodyssey-store-01-thumb.webp';
import BalloonsOdysseyStore02_Thumb from '../images/optimized/balloonsodyssey-store-02-thumb.webp';
import BalloonsOdysseyStore03_Thumb from '../images/optimized/balloonsodyssey-store-03-thumb.webp';
import BalloonsOdysseyStore04_Thumb from '../images/optimized/balloonsodyssey-store-04-thumb.webp';
import BalloonsOdysseyStore05_Thumb from '../images/optimized/balloonsodyssey-store-05-thumb.webp';

import BalloonsOdysseySkinTraveler_Thumb from '../images/optimized/balloonsodyssey-skin-traveler-thumb.webp';
import BalloonsOdysseySkinBeta_Thumb from '../images/optimized/balloonsodyssey-skin-beta-thumb.webp';
import BalloonsOdysseySkinWizard_Thumb from '../images/optimized/balloonsodyssey-skin-wizard-thumb.webp';


function Cards() {
  return (
    <div className="cards">
      <h1 className="cards-title">Check out some of my projects</h1>
      <div className="cards-container">
        <div className="cards-wrapper">
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdyssey_Thumb}
              text="Balloons Odyssey: a casual puzzle game fully developed by me, schedule for release in 2022"
              label="Games"
              path="/balloonsodyssey"
            />
            <CardItem
              src={AGoodAlien_Thumb}
              text="A Good Alien: my first multiplayer game development project"
              label="Games"
              path="/agoodalien"
            />
            <CardItem
              src={KingsPath_Thumb}
              text="King's' Path: my first game development project"
              label="Games"
              path="/kingspath"
            />
          </ul>
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdysseyWorldGUI_Thumb}
              text="Balloons Odyssey: world GUI"
              label="Interface"
              path="/balloonsodyssey-worldGUI"
            />
            <CardItem
              src={BalloonsOdysseyTournament_Thumb}
              text="Balloons Odyssey: tournament"
              label="Interface"
              path="/balloonsodyssey-tournament"
            />
          </ul>
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdysseySkinTraveler_Thumb}
              text="Balloons Odyssey: traveler skin"
              label="Skin"
              path="/balloonsodyssey-travelerskin"
            />
            <CardItem
              src={BalloonsOdysseySkinBeta_Thumb}
              text="Balloons Odyssey: beta Skin"
              label="Skin"
              path="/balloonsodyssey-betaskin"
            />
            <CardItem
              src={BalloonsOdysseySkinWizard_Thumb}
              text="Balloons Odyssey: wizard Skin"
              label="Skin"
              path="/balloonsodyssey-wizardskin"
            />
          </ul>
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdysseyWorld01_Thumb}
              text="Balloons Odyssey: farm map"
              label="Map"
              path="/balloonsodyssey-world01"
            />
            <CardItem
              src={BalloonsOdysseyWorld02_Thumb}
              text="Balloons Odyssey: farm to forest map"
              label="Map"
              path="/balloonsodyssey-world02"
            />
          </ul>
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdysseyWorld03_Thumb}
              text="Balloons Odyssey: orange forest map"
              label="Map"
              path="/balloonsodyssey-world03"
            />
            <CardItem
              src={BalloonsOdysseyWorld04_Thumb}
              text="Balloons Odyssey: orange forest to beach map"
              label="Map"
              path="/balloonsodyssey-world04"
            />
            <CardItem
              src={BalloonsOdysseyWorld05_Thumb}
              text="Balloons Odyssey: beach map"
              label="Map"
              path="/balloonsodyssey-world05"
            />
          </ul>
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdysseyStore01_Thumb}
              text="Balloons Odyssey: combos tab"
              label="Store"
              path="/balloonsodyssey-store01"
            />
            <CardItem
              src={BalloonsOdysseyStore02_Thumb}
              text="Balloons Odyssey: boosts tab"
              label="Store"
              path="/balloonsodyssey-store02"
            />
          </ul>
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdysseyStore03_Thumb}
              text="Balloons Odyssey: coins tab"
              label="Store"
              path="/balloonsodyssey-store03"
            />
            <CardItem
              src={BalloonsOdysseyStore04_Thumb}
              text="Balloons Odyssey: skins tab"
              label="Store"
              path="/balloonsodyssey-store04"
            />
            <CardItem
              src={BalloonsOdysseyStore05_Thumb}
              text="Balloons Odyssey: stage offers tab"
              label="Store"
              path="/balloonsodyssey-store05"
            />
          </ul>
          <ul className="cards-items">
            <CardItem
              src={BalloonsOdysseyAdvertisement_Thumb}
              text="Balloons Odyssey: advertisement"
              label="Interface"
              path="/balloonsodyssey-advertisement"
            />
            <CardItem
              src={BalloonsOdysseySettings_Thumb}
              text="Balloons Odyssey: settings"
              label="Interface"
              path="/balloonsodyssey-settings"
            />
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Cards
